import FollowOrganizationModal from './FollowOrganizationModal';
export default FollowOrganizationModal;